/**!
 * Created by Leonardo Cheslacki on 03/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import mainConfig from './../../../../config/main.config';

import indexConfig from './../../../../config/index.config';

import WithType from './../WithType';

/**
 *
 */
class PageMain extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        // if (PageMain._this instanceof PageMain) {
        //     return PageMain._this;
        // }

        this.props = props;
        this.main = main;

        this.state = {
            disabled: false,
            enabled: false,
            confirm: false,
            element: null
        };

        AllTap.$tour = false;

        PageMain._this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handleStart: function (event) {
            const _this = PageMain._this;

            _this.stopPropagation(event);
            _this.getFrame().gotoAndPlay('complete');
        },

        /**
         *
         * @param event
         */
        handleBack: function (event) {
            const
                _this = PageMain._this,
                {init} = _this.props;

            _this.stopPropagation(event);

            const
                element = _this.getElementById('load_iframe'),
                {name, frame} = _this.getDefaultIndex();

            _this.gotoAndStopFrame(_this.get(), init.frame);
            _this.getFrame().gotoAndPlay('start');

            AllTap.$current_name = name;
            AllTap.$current_frame = frame;
            AllTap.$current_name_sub = null;
            AllTap.$current_frame_sub = null;

            element && element.wantDisabled(true);
            element.setAttribute('src', _this.getUriSource(AllTap.$current_name));
        },

        /**
         *
         * @param event
         * @param current_name
         * @param current_frame
         * @param btn
         * @returns {*}
         */
        handlePaginate: function (event, {current_name, current_frame, btn}) {
            const
                _this = PageMain._this,
                {init} = _this.props;

            if (init.marker) {
                _this.markerOut();

                _this.pageOut();

                AllTap.$current_name = current_name;
                AllTap.$current_frame = current_frame;
                AllTap.$current_name_sub = null;
                AllTap.$current_frame_sub = null;
            } else {
                _this.markerSliderAnimate(btn);

                _this.pageOut();

                AllTap.$current_name = current_name;
                AllTap.$current_frame = current_frame;
                AllTap.$current_name_sub = null;
                AllTap.$current_frame_sub = null;
            }

            if (AllTap.$tour) {
                AllTap.$tour = false;
                AllTap.emit('animate_end', {}, current_name);
            }
        },

        /**
         *
         * @param event
         * @param current_name
         * @param current_frame
         * @returns {*}
         */
        handlePaginateSub: function (event, {current_name, current_frame}) {
            const _this = PageMain._this;

            _this.pageOut();

            AllTap.$current_name_sub = current_name;
            AllTap.$current_frame_sub = current_frame;
        }
    };

    startPaginate = () => {
        const
            object = this.getCurrentIndex(),
            paginates = this.verifyField(object, 'paginates');

        if (this.isArrayIf(paginates)) {
            let _this_current = this.get(AllTap.$current_name);

            for (let property of paginates) {
                let
                    name = this.verifyField(property, 'name'),
                    frame = this.verifyField(property, 'frame'),
                    occ = this.padWithLeadingZeros(frame, 2),
                    btn = this.verifyField(_this_current, `btn_page${occ}`);

                if (this.getObject(property, 'default')) {
                    AllTap.$default_page_sub = () => {
                        this.$functions.handlePaginateSub(undefined, {current_name: name, current_frame: frame});
                    };
                    AllTap.$current_name_sub = name;
                    AllTap.$current_frame_sub = frame;
                }

                if (btn) {
                    this.setHandleMouseDown(btn, this.$functions.handlePaginateSub, {
                        current_name: name,
                        current_frame: frame
                    }, `paginate_sub_${occ}`);
                }
            }
        }
    };

    startIndex = () => {
        const {menu} = this.props;

        if (this.isArrayIf(menu)) {
            let _this_frame = this.getFrame();

            for (let property of menu) {
                let
                    name = this.verifyField(property, 'name'),
                    frame = this.verifyField(property, 'frame'),
                    occ = this.padWithLeadingZeros(frame, 2),
                    btn = this.verifyField(_this_frame, `btn_page${occ}`);

                if (this.getObject(property, 'default')) {
                    AllTap.$default_page = () => {
                        this.$functions.handlePaginate(undefined, {
                            current_name: name,
                            current_frame: frame,
                            btn: btn
                        });
                    };
                    AllTap.$current_name = name;
                    AllTap.$current_frame = frame;
                }

                if (btn) {
                    this.setHandleMouseDown(btn, this.$functions.handlePaginate, {
                        current_name: name,
                        current_frame: frame,
                        btn: btn
                    }, `paginate_${occ}`);
                }
            }
        }
    };

    startBefore = () => {
        const
            _this_frame = this.getFrame(),
            {btn_start} = _this_frame;

        _this_frame.gotoAndPlay('start');

        this.setHandleMouseDown(btn_start, this.$functions.handleStart);
    };

    initIndex = () => {
        const _this = PageMain._this;

        const
            {current_name, init, path, iframe, audio} = this.props,
            _this_current = this.get(),
            element = this.getElementById('load_iframe'),
            {frame} = this.getDefaultIndex();

        Boolean(init.fullscreen) && !this.isMobile() && this.fullScreen();

        if (Boolean(init.before)) {
            element && element.wantDisabled(true);
            this.gotoAndStopFrame(_this_current, init.frame);
            this.startBefore();
        } else {
            element && element.wantDisabled(false);
            this.gotoAndStopFrame(_this_current, frame);
            AllTap.$current_frame = frame;
            this.logo();
            init.marker ? this.markerIn() : this.markerSliderIn();
            this.backgroundDynamic();
            this.startIndex();
        }

        // this.removeListener('load', 'load-iframe', () => {
        //     this.addListener(element, 'load', 'load-iframe', () => {
        //         console.log('load-iframe');
        //     });
        // });

        /**
         * On of emit current_name index, correspond all animate_complete.
         */
        AllTap.on('animate_complete', () => {
            const
                object = this.getCurrentIndex(),
                paginates = _this.getObject(object, 'paginates');

            if (this.getObject(object, 'type') === 'audio') {
                const playAudio = () => {
                    if (!audio.all) {
                        this.pauseAudio(() => {
                            this.readAudio(this.getObject(object, 'uri'));
                        });
                    } else {
                        !this.checkAudio() && this.readAudio(this.getObject(object, 'uri'));
                    }
                };

                this.setState({...this.state, enabled: false}, playAudio);

                AllTap.on('play_audio', playAudio, 'confirm_play_audio');
            } else {
                !audio.all && this.pauseAudio();
            }

            _this.isArrayIf(paginates) && this.startPaginate();

        }, current_name);

        /**
         * On of emit current_name index, correspond all animate_end.
         */
        AllTap.on('animate_end', ({current_name}) => {
            /**
             * Provisional
             */
            const {document} = window.top;

            let element_menu = document.getElementById('load_iframe_menu');

            if (element_menu) {
                element_menu.remove();
                element_menu = null;
            }
            /**
             * End Provisional
             */

            if (current_name === 'index') {
                element && element.wantDisabled(false);
                this.gotoAndStopFrame(this.get(), frame);
                AllTap.$current_frame = frame;
                this.logo();
                init.marker ? this.markerIn() : this.markerSliderIn();
                this.backgroundDynamic();
                this.startIndex();

                if (Boolean(init.before)) {
                    const {btn_back} = this.getFrame();

                    btn_back.visible = true;

                    this.setHandleMouseDown(btn_back, this.$functions.handleBack);
                }
            } else {
                const object = this.getCurrentIndex();

                if (this.isEmpty(AllTap.$current_name_sub)) {
                    this.logo();
                    init.marker ? this.markerIn() : this.markerSliderIn();
                    this.backgroundDynamic();
                }

                if (this.getObject(object, 'type') === 'audio') {
                    this.readAudio(this.getObject(object, 'uri'));
                }

                switch (this.getObject(object, 'type')) {
                    case 'video':
                        this.checkAudio() && this.pauseAudio();
                        element && element.wantDisabled(true);
                        this.openVideo(null, object);
                        break;
                    case 'tour':
                        element && element.wantDisabled(true);
                        this.openTour(null, object);
                        break;
                    case 'external':
                        element && element.wantDisabled(true);
                        this.openExternal(null, object);
                        break;
                    case 'paginate':
                        element && element.wantDisabled(false);

                        const
                            paginates = this.getObject(object, 'paginates'),
                            paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

                        AllTap.$current_name_sub = this.getObject(paginate, 'name');

                        /**
                         * Provisional
                         */
                        let menu = this.getObject(paginate, 'menu');

                        if (!element_menu && menu) {
                            let element_iframe = document.createElement('IFRAME');

                            let bottom = this.calcSize(1080, window.anim_container.clientHeight, 90, false, 'int');

                            this.setAttributes(element_iframe, {
                                ...iframe.attributes,
                                src: `${this.$base_uri}/${path.uri_src}/menu/menu.html`,
                                id: 'load_iframe_menu',
                                width: this.calcSize(1920, window.anim_container.clientWidth, 1920, false, 'int'),
                                height: this.calcSize(1080, window.anim_container.clientHeight, 80, false, 'int'),
                                style: `top: auto; bottom: ${bottom}px;`
                            });

                            anim_container.prepend(element_iframe);

                            AllTap.$iframeResize = element_iframe;
                        }
                        /**
                         * End Provisional
                         */

                        /**
                         * Provisional
                         */
                        let type = this.getObject(paginate, 'type');
                        if (type === 'tour') {
                            let uri = this.getObject(paginate, 'uri');
                            element.contentWindow.location.replace(uri);
                            AllTap.$tour = true;
                        } else {
                            element.contentWindow.location.replace(this.getUriSource(AllTap.$current_name, `${AllTap.$current_name_sub}/${AllTap.$current_name_sub}`));
                        }
                        /**
                         * End Provisional
                         */
                        break;
                    default:
                        element && element.wantDisabled(false);
                        element.contentWindow.location.replace(this.getUriSource(AllTap.$current_name));
                }
            }
        }, current_name);
    };
}

/**
 *
 * @type {{}}
 */
PageMain.propTypes = {
    current_name: PropTypes.string,
    init: PropTypes.object,
    menu: PropTypes.array,
    path: PropTypes.object,
    iframe: PropTypes.object,
    audio: PropTypes.object
};

/**
 *
 * @type {{}}
 */
PageMain.defaultProps = {
    current_name: null,
    init: indexConfig.init,
    menu: indexConfig.menu,
    path: mainConfig.path,
    iframe: mainConfig.iframe,
    audio: mainConfig.audio
};

/**
 *
 * @type {{}}
 * @private
 */
PageMain._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageMain, {className: 'PageMain'});
